import { deviceType } from "../../helper/enum/deviceType";

const state = {
  currentRoute: "/login",
  sidebarMargin: 300,
  contentMargin: 300,
  deviceType: deviceType.TABLET,
  isProgressVisible: false,
  translate3D: true,
  previousPage: 1,
  userEmail: "",
  designation: "",
  departmentName: "",
  finalPagePermision: ""
};

const mutations = {
  SET_CURRENT_ROUTE(state, payload) {
    state.currentRoute = payload;
  },
  SET_SIDEBAR_MARGIN(state, payload) {
    state.sidebarMargin = payload;
    console.log(state, payload);
    if (state.deviceType == deviceType.PHONE) {
      state.contentMargin = 0;
    } else if (state.deviceType == deviceType.TABLET) {
      state.contentMargin = payload;
    } else {
      state.contentMargin = payload;
    }
  },
  SET_DEVICE_TYPE(state, payload) {
    state.deviceType = payload;
  },
  SET_IS_PROGRESS_VISIBLE(state, payload) {
    state.isProgressVisible = payload;
  },
  SET_TRASLATE3D(state, payload) {
    state.translate3D = payload;
  },
  SET_PREVIOUS_PAGE(state, payload) {
    state.previousPage = payload;
  },
  SET_USER_EMAIL: (state, payload) => {
    state.userEmail = payload;
  },
  SET_USER_DEPARTMENT: (state, payload) => {
    state.departmentName = payload;
  },

  SET_PAGE_PER: (state, payload) => {
    state.finalPagePermision = payload;
  },
  SET_USER_DESIGNATION: (state, payload) => {
    state.designation = payload;
  }
};

const actions = {
  setCurrentRoute({ commit }, payload) {
    commit("SET_CURRENT_ROUTE", payload);
  },
  setSidebarMargin({ commit }, payload) {
    commit("SET_SIDEBAR_MARGIN", payload);
  },
  setDeviceType({ commit }, payload) {
    commit("SET_DEVICE_TYPE", payload);
  },
  setIsProgressVisible({ commit }, payload) {
    commit("SET_IS_PROGRESS_VISIBLE", payload);
  },
  setTranslate3d({ commit }, payload) {
    commit("SET_TRASLATE3D", payload);
  },
  setPreviousPage({ commit }, payload) {
    commit("SET_PREVIOUS_PAGE", payload);
  },
  setUserEmail({ commit }, payload) {
    commit("SET_USER_EMAIL", payload);
  },
  setUserDesignation({ commit }, payload) {
    commit("SET_USER_DESIGNATION", payload);
  },
  setUserDepartment({ commit }, payload) {
    commit("SET_USER_DEPARTMENT", payload);
  },
  setPagePermision({ commit }, payload) {
    commit("SET_PAGE_PER", payload);
  }
};

const getters = {
  appCurrentRoute: state => state.currentRoute,
  appSidebarMargin: state => state.sidebarMargin,
  appContentMargin: state => state.contentMargin,
  appDeviceType: state => state.deviceType,
  appIsProgressVisible: state => state.isProgressVisible,
  appTranslate3D: state => state.translate3D,
  appPreviousPage: state => state.previousPage,
  userEmail: state => state.userEmail,
  departmentName: state => state.departmentName,
  designation: state => state.designation,
  finalPagePermision: state => state.finalPagePermision
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/module/app.js